'use strict'

document.addEventListener("DOMContentLoaded", function (event) {
    /********************************
     * Common Variables
     *******************************/
    const body = document.querySelector('body');

    /********************************
     * MENU
     *******************************/
    const showMobileMenu = document.querySelector('.show-mobile-menu');
    const hideMobileMenu = document.querySelector('.hide-mobile-menu');

    /****** Show menu ******/
    showMobileMenu.addEventListener('click', (event) => {
        body.classList.add('show-menu');
        event.stopPropagation();

        /********* HIDE MENU -OUT MENU *********/
        let listener = function ({target}) {
            if (!target.closest('.site-navigation')) {
                body.classList.remove('show-menu');
                body.removeEventListener('click', listener);
            }
        };

        body.addEventListener('click', listener);

    });

    /****** Hide menu ******/
    hideMobileMenu.addEventListener('click', () => body.classList.remove('show-menu'));

    /****** Navigate menu ******/
    const navBar = document.querySelector('.header-mega-menu .nav-bar');
    const menuWrapper = document.querySelector('ul.site-nav');

    if(window.innerWidth <= 991 && navBar){
        menuWrapper.addEventListener('click', (event) => {
            const target = event.target;

            /*** Next Step ***/
            const listItem = target.closest('li.has-child')

            if (listItem.classList.contains('next-step')) {
                //event.preventDefault();

                const dropDownMenu = listItem.querySelector('.submenu');

                if(dropDownMenu.classList.contains('second-step-list')){
                    menuWrapper.style.left = `-100%`;
                    dropDownMenu.classList.add('active');
                }

                if(dropDownMenu.classList.contains('third-step-list')){
                    menuWrapper.style.left = `-200%`;
                    dropDownMenu.classList.add('active');
                }

                scrollToTopNav();
            }

            /*** Previous Step ***/
            if(target.classList.contains('back-to-previous-menu')){
                const dropDownMenu = target.closest('.submenu');

                if(dropDownMenu.classList.contains('second-step-list')){
                    menuWrapper.style.left = `0`;
                    dropDownMenu.classList.remove('active');
                }

                if(dropDownMenu.classList.contains('third-step-list')){
                    menuWrapper.style.left = `-100%`;
                    dropDownMenu.classList.remove('active');
                }

                scrollToTopNav();
            }
        });
    }

    function scrollToTopNav () {
        document.querySelector('.nav-bar').scrollTo(0, 0)
    }
});


